import React from 'react';

const ICONS = {
  desktop: '💻',
  mobile: '📱',
  tablet: '📟',
};

function DeviceIcons({ devices = [] }) {
  if (!devices.length) return <span title="Unknown device">❔</span>;
  const uniq = Array.from(new Set(devices.map((d) => String(d || '').toLowerCase())));
  return (
    <span title={uniq.join(', ')}>
      {uniq.slice(0, 3).map((d) => (
        <span key={d} style={{ marginRight: 4 }}>
          {ICONS[d] || '🖥️'}
        </span>
      ))}
      {uniq.length > 3 && <span>+</span>}
    </span>
  );
}

export default DeviceIcons;
